import { FC, useEffect, useState } from 'react'

import './style.scss'
import { utils } from '../../../utils'
import { Card, Icon, Loading, Paginate, Table, TableLabel, TableText, Text } from '../../UI'

type ContactsPreviousProps = {
  className?: string,
  data: any | null,
  pageDefault: number,
  pageSizeDefault: number,
  onPageChange(pageCurrent: number): void
}

const TableNote:FC<{ className?: string, size?: string }> = ({ className = '', size = '13' }) => {
  return (
    <div className={className}>
      <Text size={size}>Para solicitar copia de tu carta de respuesta, favor contáctanos al siguiente correo:</Text>
      <a href="mailto:servicio.atencionclientes@indisa.cl" className={`link text-primary fz-${size} mt-10`}>Servicio.atencionclientes@indisa.cl</a>
    </div>
  )
}

const ContactsPrevious:FC<ContactsPreviousProps> = ({ className, data, pageDefault, pageSizeDefault, onPageChange }) => {
  const tableAttrsShowDefault = utils.getArrayBooleanDefault(pageSizeDefault)
  const [tableAttrsShow, setTableAttrsShow] = useState<boolean[]>(tableAttrsShowDefault)
  const [pageCurrent, setPageCurrent] = useState<number>(pageDefault)
  const [pageLoad, setPageLoad] = useState<boolean>(false)

  useEffect(() => {
    setPageLoad(false)
  }, [data])

  const tableColumns = [
    {
      accessor: 'reason_contact.name',
      Header: 'Motivo del contacto',
      width: '25%'
    },
    {
      accessor: 'patient_full_name',
      Header: 'Paciente',
      width: '40%',
    },
    {
      accessor: 'application_date',
      Header: 'Fecha solicitud',
      width: '15%'
    },
    {
      accessor: 'answer',
      Header: 'Solicitar respuesta',
      width: '20%',
      enableRowSpan: true,
      Cell: () => {
        return (
          <div className="d-flex align-items-center justify-content-center text-center h-full">
            <TableNote size="12" />
          </div>
        )
      }
    }
  ]

  const onTableBtnShowMore = (index: number) => {
    setTableAttrsShow(prevState => prevState.map((item, idx) => idx === index ? !item : item))
  }

  const onPaginateChange = (pageCurrent: number) => {
    setPageCurrent(pageCurrent)
    setPageLoad(true)
    onPageChange(pageCurrent)
  }

  return (
    <div className={`contact-wrapper ${className}`}>
      {data ?
          data.contactUs && data.contactUs.length ?
            <>
              <div className="position-relative d-none lg:d-block">
                <Table
                  columns={tableColumns}
                  data={data.contactUs}
                />
                {pageLoad && <Loading overlay />}
              </div>

              <div className="position-relative d-block lg:d-none">
                {data.contactUs.map((it: any, i: number) =>
                  <Card key={i} className={`py-20 px-25 ${i > 0 ? 'mt-20' : ''}`}>
                    <div>
                      <TableLabel>Motivo del contacto</TableLabel>
                      <TableText>{it.reason_contact?.name}</TableText>
                    </div>

                    <div className="mt-10">
                      <TableLabel>Fecha solicitud</TableLabel>
                      <TableText>{it.application_date}</TableText>
                    </div>

                    {tableAttrsShow[i] &&
                      <>
                        <div className="mt-10">
                          <TableLabel>Paciente</TableLabel>
                          <TableText>{it.patient_full_name}</TableText>
                        </div>

                        <div className="text-center mt-20">
                          <TableNote className="px-20" />
                        </div>
                      </>
                    }

                    {!tableAttrsShow[i] &&
                      <div className="text-center mt-20" onClick={() => onTableBtnShowMore(i)}>
                        <div className="d-inline px-10">
                          <Icon name="arrow-down" />
                        </div>
                      </div>
                    }
                  </Card>
                )}
                {pageLoad && <Loading overlay />}
              </div>

              <div className="text-center mt-30 lg:mt-20">
                <Paginate
                  current={pageCurrent}
                  total={data ? data.count : 0}
                  size={pageSizeDefault}
                  onPageChange={onPaginateChange}
                />
              </div>
            </>
          :
            <div className="contact-empty">
              <Text size="20" weight="bold">Aún no tienes contactos anteriores</Text>
            </div>
        :
          <Loading size="md" align="center" className="pt-70 lg:pt-100" />
      }
    </div>
  )
}

export { ContactsPrevious }